var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Sidebar',{attrs:{"title":"Η ΟΜΑΔΑ ΜΑΣ","items":_vm.services}})}
var staticRenderFns = []

export { render, staticRenderFns }